import { cn } from 'cn';
import type { ReactNode } from 'react';

export type SectionHeaderProps = {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  variant?: 'light' | 'dark';
  gradient?: 'green' | 'yellow';
};

export function SectionHeader({
  icon,
  title,
  subtitle,
  variant = 'light',
  gradient = 'green',
}: SectionHeaderProps) {
  const dark = variant === 'dark';

  return (
    <div className={cn('flex items-start', dark ? 'mb-4 flex-col' : 'mb-7 gap-4')}>
      <div
        className={cn(
          'flex size-11 shrink-0 items-center justify-center rounded-icon',
          dark
            ? 'mb-2 border border-primary-foreground/20 bg-primary-foreground/12 text-primary-foreground/85'
            : gradient === 'green'
              ? 'bg-gradient-to-br from-accent to-section-header-green-end text-accent-foreground'
              : 'bg-gradient-to-br from-section-header-yellow-start to-section-header-yellow-end text-section-header-yellow-foreground',
        )}
      >
        {icon}
      </div>
      <div>
        <h2 className={cn('typography-large-headline mb-1', dark && 'text-primary-foreground')}>
          {title}
        </h2>
        {subtitle && (
          <p
            className={cn(
              'typography-text-small',
              dark ? 'text-primary-foreground/55' : 'text-muted-foreground',
            )}
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}
